var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowthOpportunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 19.5C40.5907 19.498 42.1157 18.8652 43.2404 17.7404C44.3652 16.6157 44.998 15.0907 45 13.5V9H40.5C38.9642 9.00227 37.4884 9.59646 36.3795 10.659C35.6024 9.24904 34.4616 8.07315 33.0758 7.25376C31.69 6.43436 30.1099 6.00142 28.5 6H24V10.5C24.0028 12.8861 24.9519 15.1737 26.6391 16.8609C28.3263 18.5481 30.6139 19.4972 33 19.5H34.5V39H16.5V31.5H18C19.5907 31.498 21.1157 30.8652 22.2404 29.7404C23.3652 28.6157 23.998 27.0907 24 25.5V21H19.5C17.9642 21.0023 16.4884 21.5965 15.3795 22.659C14.6024 21.249 13.4616 20.0732 12.0758 19.2538C10.69 18.4344 9.10992 18.0014 7.5 18H3V22.5C3.00278 24.8861 3.95188 27.1737 5.63911 28.8609C7.32633 30.5481 9.6139 31.4972 12 31.5H13.5V39H3V42H45V39H37.5V19.5H39ZM37.5 15C37.5008 14.2046 37.8171 13.442 38.3796 12.8796C38.942 12.3171 39.7046 12.0008 40.5 12H42V13.5C41.9992 14.2954 41.6829 15.058 41.1204 15.6204C40.558 16.1829 39.7954 16.4992 39 16.5H37.5V15ZM16.5 27C16.5008 26.2046 16.8171 25.442 17.3796 24.8796C17.942 24.3171 18.7046 24.0008 19.5 24H21V25.5C20.9992 26.2954 20.6829 27.058 20.1204 27.6204C19.558 28.1829 18.7954 28.4992 18 28.5H16.5V27ZM13.5 28.5H12C10.4093 28.498 8.88434 27.8652 7.75955 26.7404C6.63476 25.6157 6.00198 24.0907 6 22.5V21H7.5C9.09069 21.002 10.6157 21.6348 11.7404 22.7596C12.8652 23.8843 13.498 25.4093 13.5 27V28.5ZM34.5 16.5H33C31.4093 16.498 29.8843 15.8652 28.7596 14.7404C27.6348 13.6157 27.002 12.0907 27 10.5V9H28.5C30.0907 9.00198 31.6157 9.63476 32.7404 10.7596C33.8652 11.8843 34.498 13.4093 34.5 15V16.5Z",
    fill: "url(#paint0_linear_1235_8178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235_8178",
    x1: 3,
    y1: 6,
    x2: 45,
    y2: 47.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthOpportunities);
export default __webpack_public_path__ + "static/media/Growth_Opportunities.493dcc546d2db88f570cb5fdbae4c62a.svg";
export { ForwardRef as ReactComponent };